export default {
  'viewCriteria.heading': 'View Account Activity',
  'viewCriteria.saveAs': 'Save this report criteria',
  'viewCriteria.duplicateReport': 'Save Report <%= reportName %> will be overwritten'
};
